import { publicGet, publicPost } from "../clients/createPublicClient";
import {
  CPInvitationInfo,
  CustomerUserLoginRequest,
  CustomerUserLoginResult,
  CustomerUserPasswordResetRequest,
  CustomerUserPasswordResetToComplete,
  CustomerUserRegisterRequest,
  ExchangeSignInAsTokenRequest,
} from "../models/unified";

export default {
  register: async (values: CustomerUserRegisterRequest) => {
    const result = await publicPost<CustomerUserLoginResult>(
      `customerPortal/public/v2/register`,
      values,
    );

    return result;
  },
  login: async (values: CustomerUserLoginRequest) => {
    const result = await publicPost<CustomerUserLoginResult>(
      `customerPortal/public/v2/login`,
      values,
    );

    return result;
  },
  requestPasswordReset: async (values: CustomerUserPasswordResetRequest) => {
    const result = await publicPost<undefined>(
      `customerPortal/public/v2/requestPasswordReset`,
      values,
    );

    return result;
  },
  completePasswordReset: async (
    values: CustomerUserPasswordResetToComplete,
  ) => {
    const result = await publicPost<CustomerUserLoginResult>(
      `customerPortal/public/v2/completePasswordReset`,
      values,
    );

    return result;
  },
  validateInvitationGuid: async (invitationGuid: string) => {
    const result = await publicGet<CPInvitationInfo>(
      `customerPortal/public/v2/registerationValidate`,
      { invitationGuid },
    );

    return result;
  },
  refreshTokens: async (refreshToken: string) => {
    const result = await publicPost<CustomerUserLoginResult>(
      "customerPortal/public/v2/renewTokens",
      { refreshToken },
    );

    return result;
  },
  exchangeSignInAsToken: async (data: ExchangeSignInAsTokenRequest) => {
    const result = await publicPost<CustomerUserLoginResult>(
      "customerPortal/public/v2/exchangeSignInAsToken",
      data,
    );

    return result;
  },
};
